import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ListProductProxyByGroupProductComponent
    from "../../../components/Customer/products/ListProductProxyByGroupProductComponent";

const ListProductProxyByGroupProductPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/');
    }

    return <ListProductProxyByGroupProductComponent groupProductId={ params.groupProductId }
                                                    shouldRedirect={ () => redirect() }
    />;
}

export default ListProductProxyByGroupProductPage;